// Default images used throughout the app when user hasn't uploaded their own

// Professional demo avatar - gradient placeholder with initials
export const getDefaultAvatar = (name = 'User') => {
  return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(name || 'U')}&backgroundColor=0a66c2,057642,5f3dc4,c2185b,b24020&backgroundType=gradientLinear&fontFamily=Arial&fontSize=40`;
};

// Default cover photo - beautiful campus/academic imagery
export const DEFAULT_COVER = 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&h=200&fit=crop&q=80';

// Alternative covers for variety
export const COVER_OPTIONS = [
  'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?w=800&h=200&fit=crop&q=80', // university
  'https://images.unsplash.com/photo-1523050854058-8df90110c476?w=800&h=200&fit=crop&q=80', // library
  'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&h=200&fit=crop&q=80', // books
  'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=800&h=200&fit=crop&q=80', // lecture
];

// Community default cover
export const DEFAULT_COMMUNITY_COVER = 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=800&h=200&fit=crop&q=80';

// Get a deterministic cover based on user/community ID
export const getCoverForId = (id) => {
  if (!id) return DEFAULT_COVER;
  const hash = id.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return COVER_OPTIONS[hash % COVER_OPTIONS.length];
};
